import React from 'react';
const investors = [{
  name: 'Alchemist Accelerator',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/alchemist-logo.png",
  href: 'https://www.alchemistaccelerator.com'
}, {
  name: 'Race Capital',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/race-capital.png",
  href: 'https://www.race.capital'
}, {
  name: 'Antler',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/antler.png",
  href: 'https://www.antler.co'
}, {
  name: 'Sunset Ventures',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/sunset_ventures_light_(1).png",
  href: 'https://x.com/SunsetVC'
}, {
  name: 'GoAhead Ventures',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/goahead-ventures.png",
  href: 'https://www.goaheadvc.com/'
}];
export function VCLogos() {
  // Duplicate the list for seamless infinite scroll
  const allLogos = [...investors, ...investors];
  return <section className="relative w-full bg-navy pt-4 pb-8 overflow-hidden" data-id="element-521" data-mp="3vgrxnw6ebuhn">
      {/* Top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-522" data-mp="vzshnisintjf" />

      <p className="text-center text-white/30 text-sm font-medium tracking-[0.2em] uppercase mb-10" data-id="element-523" data-mp="qzny1jwbaioz">
        Backed by leading investors
      </p>

      {/* Marquee container */}
      <div className="relative" data-id="element-524" data-mp="i0kj8s46gpga">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-525" data-mp="37qxllgtwi9yg" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-526" data-mp="32te6yftajv5z" />

        <div className="flex animate-marquee" data-id="element-527" data-mp="39838tj3t7cs7">
          {allLogos.map((investor, index) => <a key={`${investor.name}-${index}`} href={investor.href} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mx-12 flex items-center justify-center group" data-id="element-528" data-mp="2v7sf88b47k3c" data-mpi={index}>
            
              <img src={investor.logo} alt={investor.name} className="h-16 w-auto max-w-[240px] object-contain transition-all duration-300 cursor-pointer brightness-0 invert" style={{
            opacity: 0.4
          }} onMouseEnter={e => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.filter = 'brightness(0) invert(1) drop-shadow(0 0 12px rgba(255,255,255,0.4))';
          }} onMouseLeave={e => {
            e.currentTarget.style.opacity = '0.4';
            e.currentTarget.style.filter = 'brightness(0) invert(1)';
          }} data-id="element-529" data-mp="2lhz57bqmfd17" />
            
            </a>)}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-530" data-mp="1nwxwxp9ddrzr" />
    </section>;
}